import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasSearchQuery: boolean
}

const EmptyInsuranceProductsComponent = ({ hasSearchQuery }: Props) => {
  return (
    <div
      data-testid="insurance-products-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No insurance products found</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {hasSearchQuery ? 'Try a different search.' : 'Add a product to get started.'}
      </Typography>
    </div>
  )
}

export const EmptyInsuranceProducts = memo(EmptyInsuranceProductsComponent)
